import React from 'react';
import { Typography, Button } from '@mui/material';
import apiClient from '../../../shared/auth.interceptor';
import { Company } from '../clients-list';
import styles from '../../../../index.module.scss';
import { toast } from 'react-toastify';
import BaseModal from '../../../shared/components/base.modal';
import { errorToast } from '../../../shared/toast.service';
import { IFirm } from '../../../shared/redux/firmSlicer';

interface TimeZoneSelectModalProps {
  open: boolean;
  firmId?: string;
  handleClose: () => void;
  client: Company;
  onSuccess: (firms: IFirm[]) => void;
}

const DeleteClientModal: React.FC<TimeZoneSelectModalProps> = ({ open, handleClose, onSuccess, client, firmId }) => {
  const [saving, setSaving] = React.useState(false);
  const handleUpdate = () => {
    if (saving || !firmId) return;
    setSaving(true);
    apiClient
      .delete<IFirm[]>(`/v1/firm/${firmId}/clients/${client.realmId}`)
      .then((user) => {
        toast.success('Client deleted successfully');
        onSuccess(user.data);
        handleClose();
      })
      .catch(() => {
        errorToast('Failed to delete client');
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <BaseModal open={open} handleClose={() => { if (!saving) handleClose(); }}>
      <h2 className="fw-bold my-3">Delete Client</h2>
      <img alt={'Logo'} src="/logo120.svg" />
      <p className="my-5">
        Are you sure you want to <br /> delete the client?
      </p>
      <Typography sx={{ color: styles.mainGreen, textDecorationLine: 'underline', fontSize: '1.6rem' }}>
        {client?.companyName}
      </Typography>
      <div className="d-flex justify-content-between my-3">
        <Button disabled={saving} onClick={handleClose} variant="contained" sx={{ mt: 2, bgcolor: styles.mainGrey, width: '136px' }}>
          No
        </Button>
        <Button disabled={saving || !firmId} onClick={handleUpdate} variant="contained" sx={{ mt: 2, bgcolor: styles.mainBlue, width: '136px' }}>
          Yes
        </Button>
      </div>
    </BaseModal>
  );
};

export default DeleteClientModal;
